import {
  CreateNpsIntentDocument,
  CreateNpsIntentMutationVariables,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateNpsIntent = () => {
  const [createNpsIntent, { loading }] = useMutation(CreateNpsIntentDocument, {
    extractorFn: (data) => data.npsMutations.createNpsSurveyResponseIntent,
  })
  const {
    company: { id: companyId },
  } = useCurrentSession()

  return {
    loading,
    create(variables: Omit<CreateNpsIntentMutationVariables, 'companyId'>) {
      return createNpsIntent({
        variables: { ...variables, companyId },
      })
    },
  }
}
